import { useCallback, useEffect, useMemo, useState } from "react";
import { useGetRole } from "../../../lib/hooks/getRole";
import { usePrevious } from "../../../lib/hooks/previous";
import AccountsService from "../../../services/accounts";
import ContractsService from "../../../services/accounts/contracts";
import { useSearchParams } from "react-router-dom";

export const useFetchDataCount = (isOther: boolean) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, isAdmin] = useGetRole();

  const [isLoading, setIsLoading] = useState(false);

  const [total, setTotal] = useState<number>(1);

  const onSuccess = useCallback((res: number) => {
    setIsLoading(false);
    setTotal(res);
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();

  const setInitRequestFromQuery = useCallback(
    (key: string, data: any) => {
      const val = searchParams.get(key);

      if (val) {
        data[key] = val;
      }
    },
    [searchParams],
  );

  const request = useMemo(() => {
    const val: any = {
      pageNumber: +(searchParams.get("pageNumber") || 1),
      pageSize: +(searchParams.get("pageSize") || 50),
    };

    const statusFilter = searchParams.getAll("statusFilter");
    const isOtherQuery = searchParams.get("isOther");

    setInitRequestFromQuery("dateFilter", val);
    setInitRequestFromQuery("dateFilterNextPayment", val);
    setInitRequestFromQuery("contractNumberCrossReference", val);
    setInitRequestFromQuery("propertyAddress", val);
    setInitRequestFromQuery("primaryPayerFullName", val);
    setInitRequestFromQuery("primaryPayeeFullName", val);
    setInitRequestFromQuery("paymentRestriction", val);
    setInitRequestFromQuery("order", val);

    if (statusFilter && statusFilter.length > 0) {
      val.statusFilter = statusFilter.map((i: string) => +i);
    }

    if (isOther) {
      val.isOther = true;
    } else if (isOtherQuery === "false") {
      val.isOther = false;
    }

    return val;
  }, [searchParams, setInitRequestFromQuery, isOther]);

  const prevRequest = usePrevious(request);

  const fetchDataCount = useCallback(() => {
    setIsLoading(true);
    !isAdmin
      ? AccountsService.fetchAccountsCount(request).then(onSuccess)
      : ContractsService.fetchCount(request).then(onSuccess);
  }, [isAdmin, request, onSuccess]);

  useEffect(() => {
    if (
      !prevRequest ||
      prevRequest.statusFilter !== request.statusFilter ||
      prevRequest.contractNumberCrossReference !==
        request.contractNumberCrossReference ||
      prevRequest.propertyAddress !== request.propertyAddress ||
      prevRequest.primaryPayerFullName !== request.primaryPayerFullName ||
      prevRequest.primaryPayeeFullName !== request.primaryPayeeFullName ||
      prevRequest.dateFilter !== request.dateFilter ||
      prevRequest.dateFilterNextPayment !== request.dateFilterNextPayment ||
      prevRequest.paymentRestriction !== request.paymentRestriction ||
      prevRequest.isOther !== request.isOther
    ) {
      fetchDataCount();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataCount]);

  return { total, isLoading, request, fetchDataCount, setSearchParams };
};
